import React, { Component } from 'react';
import ServicesSection from './ServicesSection'

import '../css/Services.css'
import braFittings from '../img/bra.jpg'
import wigsImg from '../img/wigs_comp.jpg'
import mannImg from '../img/Services/Mannequin_shop.jpg'
// import headsImg from '../img/Services/Heads_shop.jpg'
import mannBackImg from '../img/Services/Mannequin_back.jpg'
import lingerieImg from '../img/lingerie_comp.jpg'
import shopImg from '../img/Services/Shop_full.png'
import counterImg from '../img/Services/Counter_shop.jpg'

class Services extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }
  
  getInitialState() {
    return {
    sections: [
      {
        display: true,
        image: counterImg,
        top: true
      },
      {
        title: "Professional Bra Fittings",
        text: "Come in and experience a complimentary professional fitting. Our goal is to fit you in the proper bra for your body shape and lifestyle. We want you to look and feel fabulous. It’s all about you!!!!",
        image: braFittings,
        side: "Left"
      },
      {
        display: true,
        image: shopImg,
      },
      {
        title: "Beautiful Wigs",
        text: "Thinning hair, no hair, chemo treatments or just want to change your look. We have over 65 wigs in stock. one of them is sure to give you the look you want, within your budget. Come in for a fun experience and go out a new you!",
        image: wigsImg,
        side:"Right"
      },
      {
        display: true,
        image: mannImg,
      },
      {
        title: "Post Mastectomy Products ",
        text: "We carry Anita and Amoena care products; consisting of mastectomy bras, breast forms, swimwear, and casual wear. Our professional fitters will insure that you are in the proper size for your comfort and satisfaction. We direct bill to msi, your Nova Scotia health portion of $150.00 Per prosthesis.",
        image: lingerieImg,
        side:"Left"
      },
      {
        display: true,
        image: mannBackImg,
      },
      ]
    }
  }

  render() {
    return (

      <div className="services">
        {this.state.sections.map((section, i) => {
          return <ServicesSection index={i} key={i} {...section} />
        })}
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.jsx